import angular from "angular";
import { directiveFactory } from "../angular-core";

interface ILocalScope extends ng.IScope {
    selectedCoordinates: any;
}

class DragSelectController {
    static $inject = ["$scope", "$element", "$document"];

    constructor(protected $scope: ILocalScope, protected $element: JQLite, protected $document: ng.IDocumentService) {}

    $onInit = () => {
        if (this.$scope.selectedCoordinates) {
            this.init();
        }
    };

    clearFlag = false;
    startCell: $TSFixMe = null;
    dragging = false;
    finalCell: $TSFixMe = null;

    mouseDown(el: $TSFixMe) {
        if (this.startCell || this.finalCell) {
            this.clearCells(this.startCell, this.finalCell);
            this.startCell = null;
            this.finalCell = null;
            this.$scope.selectedCoordinates = {};
        }
        this.dragging = true;
        this.setStartCell(el);
        this.setRangeArea(this.startCell, el);
    }

    mouseUp(el: $TSFixMe) {
        this.dragging = false;
        this.finalCell = el;
        this.setSelectedCells(this.startCell, this.finalCell);
        if (this.clearFlag) {
            this.clearCells(this.startCell, this.finalCell);
            this.clearFlag = false;
        }
    }

    mouseLeave(el: $TSFixMe) {
        if (this.dragging) {
            if (el.hasClass("hover-element")) {
                this.cellsBetween(this.startCell, el).each(function (this: $TSFixMe) {
                    let el = angular.element(this);
                    el.toggleClass("hover-element").addClass("default");
                });
                if (this.startCell == el) {
                    el.toggleClass("hover-element").addClass("default");
                }
            }
        } else {
            return;
        }
    }

    mouseEnter(el: $TSFixMe) {
        if (!this.dragging) {
            return;
        } else {
            this.setRangeArea(this.startCell, el);
        }
    }

    setStartCell(el: $TSFixMe) {
        this.startCell = el;
    }

    setRangeArea(start: $TSFixMe, el: $TSFixMe) {
        if (this.dragging) {
            if (el.hasClass("default")) {
                this.cellsBetween(this.startCell, el).each(function (this: $TSFixMe) {
                    let el = angular.element(this);
                    el.addClass("hover-element");
                });
            } else if (el.hasClass("hover-element") || el.hasClass("default")) {
                this.cellsBetween(this.startCell, el).each(function (this: $TSFixMe) {
                    let el = angular.element(this);
                    el.toggleClass("hover-element").addClass("default");
                });
            }

            if (!start.hasClass("highlight")) {
                this.cellsBetween(this.startCell, el).each((ele: $TSFixMe) => {
                    let el = angular.element(ele);
                    if (el.hasClass("highlight")) {
                        this.clearFlag = true;
                    }
                });
            }
        }
    }

    setSelectedCells(start: $TSFixMe, end: $TSFixMe) {
        if (start && end) {
            this.cellsBetween(start, end).each(function (this: $TSFixMe) {
                let el = angular.element(this);
                if (el.hasClass("highlight") && el.hasClass("hover-element")) {
                    el.removeClass("highlight");
                    el.removeClass("hover-element");
                } else if (el.hasClass("hover-element") && !el.hasClass("highlight")) {
                    el.addClass("highlight");
                    el.removeClass("hover-element");
                }
            });
            this.$scope.selectedCoordinates = this.boundaryCoordinatesToExport(this.boundaryCoordinates(start, end));
        }
    }

    clearCells(start: $TSFixMe, end: $TSFixMe) {
        this.cellsBetween(start, end).each(function (this: $TSFixMe) {
            let el = angular.element(this);
            el.removeClass("highlight");
            el.removeClass("hover-element");
        });
    }

    cellsBetween(start: $TSFixMe, end: $TSFixMe) {
        const { topLeft, bottomRight } = this.boundaryCoordinates(start, end);
        return this.$element.find("td").filter((ele: $TSFixMe) => {
            let el = angular.element(ele);
            let coords = this.getCoords(el);
            return (
                coords.column >= topLeft.column &&
                coords.column <= bottomRight.column &&
                coords.row >= topLeft.row &&
                coords.row <= bottomRight.row
            );
        });
    }

    boundaryCoordinates(start: $TSFixMe, end: $TSFixMe) {
        let coordsStart = this.getCoords(start);
        let coordsEnd = this.getCoords(end);
        let topLeft = {
            column: Math.min(coordsStart.column, coordsEnd.column),
            row: Math.min(coordsStart.row, coordsEnd.row)
        };
        let bottomRight = {
            column: Math.max(coordsStart.column, coordsEnd.column),
            row: Math.max(coordsStart.row, coordsEnd.row)
        };
        return { topLeft, bottomRight };
    }

    boundaryCoordinatesToExport(coordinates: $TSFixMe) {
        const { topLeft, bottomRight } = coordinates;
        function correct(obj: $TSFixMe) {
            for (const i in obj) {
                if (obj.hasOwnProperty(i)) {
                    obj[i] -= 1;
                }
            }
            return obj;
        }
        return {
            topLeft: correct(topLeft),
            bottomRight: correct(bottomRight)
        };
    }

    getCoords(cell: $TSFixMe) {
        return {
            column: cell[0].cellIndex,
            row: cell.parent()[0].rowIndex
        };
    }

    wrap(fn: $TSFixMe) {
        return (ele: $TSFixMe) => {
            let el = angular.element(ele);
            this.$scope.$apply(function () {
                fn(el);
            });
        };
    }

    init() {
        this.$element.delegate("td", "mousedown", this.wrap(this.mouseDown));
        this.$element.delegate("td", "mouseenter", this.wrap(this.mouseEnter));
        this.$element.delegate("td", "mouseleave", this.wrap(this.mouseLeave));
        this.$element.delegate("td", "mouseup", this.wrap(this.mouseUp));

        this.$document.bind("click", (event: $TSFixMe) => {
            const isClickedTable = this.$element.find(event.target).length > 0;

            if (isClickedTable) return;

            if (this.startCell && this.finalCell) {
                this.clearCells(this.startCell, this.finalCell);
                this.$scope.selectedCoordinates = {};
                this.$scope.$apply();
            }
        });
    }
}
export class DragSelectDirective implements ng.IDirective<ILocalScope> {
    static componentName: string = "dragSelect";
    scope = {
        selectedCoordinates: "="
    };
    controller: any;

    constructor() {
        this.controller = DragSelectController;
    }
}

angular.module("topline.directives").directive(DragSelectDirective.componentName, directiveFactory(DragSelectDirective));